export default __webpack_public_path__ + "static/media/juego1_perder.3428ad90.png";